import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Pagination,
} from "../../../../components";
import { Stack, Text } from "@fluentui/react";
import Layout from "../../../../styles/Layout.styles";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useProjectSummaryCompleteMutation } from "../../../../store/action/projectSummary/projectSummaryComplete";
import { setProjectSummaryComplete } from "../../../../store/reducer/projectSummary/projectSummaryComplete";
import ProjectSummaryCompleteRow from "./ProjectSummaryCompleteRow";

const ProjectSummaryComplete = ({
  status,
  projectSummaryId,
  openSummaryDetails,
  setOpenSummaryDetails,
  setProjectSummaryId,
}) => {
  const layout = Layout();
  const [getProjectSummaryApi, { isLoading }] =
    useProjectSummaryCompleteMutation();
  const [initialLoad, setInitialLoad] = useState(true);
  const projectSummaryComplete = useSelector(
    (state) => state.projectSummaryComplete
  );

  const { t } = useTranslation();

  useEffect(() => {
    if (initialLoad) {
      if (!isLoading) {
        getProjectSummaryStatusApi();
        setInitialLoad(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getProjectSummaryApi, isLoading, initialLoad]);

  const getProjectSummaryStatusApi = async () => {
    await getProjectSummaryApi({ status });
  };

  const columns = [
    {
      columnKey: "projectCode",
      label: t("project_summary.project_id"),
      isSort: true,
    },
    {
      columnKey: "title",
      label: t("project_summary.project_name"),
      isSort: true,
    },
    {
      columnKey: "commencementDate",
      label: t("project_summary.commencement_date"),
      isSort: true,
    },
    {
      columnKey: "completionDate",
      label: t("project_summary.completion_date"),
      isSort: true,
    },
    {
      columnKey: "totalTeamMember ",
      label: t("project_summary.total_team_member"),
    },
    { columnKey: "todaysClockin", label: t("project_summary.today_clockin") },
  ];

  return (
    <>
      <Stack className={layout.flex_row}>
        <Stack className={layout.w_100}>
          <Stack className="overflow-x-auto">
            <Table className="tbl-layout-auto">
              <TableHeader className={layout.headerBackground}>
                <TableRow>
                  {columns?.map((column, key) => (
                    <TableHeaderCell
                      key={key}
                      onSortApi={getProjectSummaryStatusApi}
                      onSet={setProjectSummaryComplete}
                      column={column}
                      sortBy={
                        column?.isSort ? projectSummaryComplete?.sortBy : false
                      }
                    >
                      <Text className={layout.headerLabel}>{column.label}</Text>
                    </TableHeaderCell>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody isLoading={isLoading}>
                {projectSummaryComplete?.data?.map((item, key) => (
                  <ProjectSummaryCompleteRow
                    item={item}
                    key={key}
                    setOpenSummaryDetails={setOpenSummaryDetails}
                    setProjectSummaryId={setProjectSummaryId}
                    projectSummaryId={projectSummaryId}
                    openSummaryDetails={openSummaryDetails}
                  />
                ))}
              </TableBody>
            </Table>
          </Stack>

          <Pagination
            totalCount={projectSummaryComplete?.totalCount}
            itemsPerPage={projectSummaryComplete?.itemsPerPage}
            onSetListReducer={setProjectSummaryComplete}
            onGetList={getProjectSummaryStatusApi}
            page={projectSummaryComplete?.page}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default ProjectSummaryComplete;
